var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"culture"},[_c('p',[_vm._v("COMPANY CULTURE")]),_vm._v(" "),_c('h3',[_vm._v("公司文化")]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"content clearfix"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.cultrue)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-336cce39","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/About/Acom/Culture.vue
// module id = null
// module chunks = 